"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedSize = exports.DECOMPRESSING_IGNORE_DIR = exports.DECOMPRESSING_WORKSPACE_DIR = exports.DECOMPRESSING_CONCURRENCY_LEVEL = exports.HASHING_CONCURRENCY_LEVEL = exports.MAX_SUPPORTED_FILE_SIZE = exports.isWindowsOS = void 0;
const os = require("os");
const osName = require('os-name');
exports.isWindowsOS = () => osName()
    .toLowerCase()
    .indexOf('windows') === 0;
exports.MAX_SUPPORTED_FILE_SIZE = 2 * 1024 * 1024 * 1024 - 1;
exports.HASHING_CONCURRENCY_LEVEL = os.cpus().length;
exports.DECOMPRESSING_CONCURRENCY_LEVEL = os.cpus().length * 8;
exports.DECOMPRESSING_WORKSPACE_DIR = 'workspace';
exports.DECOMPRESSING_IGNORE_DIR = 'ignore';
exports.isSupportedSize = (size) => 0 < size && size < exports.MAX_SUPPORTED_FILE_SIZE;
//# sourceMappingURL=common.js.map